import React from 'react';

import './MainHomeImageAsset.css'; 

const MainHomeImageAsset = () => {
  return (
    <div className="img-wrapper">
        <img src='/vector_assets/HOME-GUEST-ASSET-FINAL_REV1.png' className="img" />
    </div>
  )
}

export default MainHomeImageAsset